
/** 混入方法 ::: 
 *  @mixin mixFormConfig 表单项属性解构混入
 */
import { mixFormConfig } from "@/mixins/common/mix_form_config.js";
/** 工具方法 :::
 *  @function makeComputedGroup 生成计算属性组方法
 */
import { makeComputedGroup } from "@/utils/computed_utils.js";


/** @name RenderItemTemplate.vue 混入
 *  @author 王汝鹏
 *  @version 2019-11-30
 */
export const mixRenderItemTemplate = {
  mixins: [ mixFormConfig ],
  inject: [ 'render_item_template_store' ],
  computed: {
    /** 计算属性说明 ::: 
     *  @return {Object} formModels 表单填写内容
     *  @return {Object} formMap 表单项字典
     */
    ...makeComputedGroup("render_item_template_store", {
      formModels: { get: "formModels" },
      formMap: { get: "formMap" }
    }),
  }
}



// WEBPACK FOOTER //
// ./src/mixins/render_item/mix_render_item_template.js